import { z } from "zod";

const ResultType = z.enum(["pass", "fail"]);
const ReviewerType = z.enum(["system", "human"]);
const IssueCategory = z.enum(["test_outcome", "anomaly", "exception"]);
const IssueSubcategory = z.enum([
  "issues_found",
  "insufficient_evidence",
  "contradictory_evidence",
  "no_issues_found",
  "unusual_transaction_pattern",
  "outlier_amount",
  "duplicate_transaction",
  "missing_supporting_documentation",
  "inconsistent_documentation",
  "late_entry",
  "nonstandard_terms_or_conditions",
  "unexpected_counterparty",
  "manual_journal_entry_exception",
  "round_number_or_estimate",
  "general_anomaly",
  "insufficient_evidence",
  "untimely_execution",
  "improper_authorization",
  "inconsistent_supporting_data",
  "access_or_permissions_exception",
  "control_not_performed",
  "unclear_or_ambiguous_evidence",
  "misstatement_of_amount",
  "unsupported_entry",
  "cutoff_misclassification",
  "valuation_error",
  "noncompliant_with_policy",
  "evidence_inconsistency",
]);

const CheckResultIssueSchema = z.object({
  issueCategory: IssueCategory,
  issueSubcategory: IssueSubcategory,
  description: z.string(),
});

const CheckResultCitationSchema = z.object({
  id: z.string().uuid(),
  documentId: z.string(),
  documentElement: z.string(),
  attributeIds: z.array(z.string()),
  shortSummary: z.string().nullable(),
  reasonSpan: z.string().nullable(),
  createdAt: z.string().or(z.date()),
  updatedAt: z.string().or(z.date()),
});

export const CheckResultSchema = z.object({
  id: z.string().uuid(),
  checkId: z.string().nullable(),
  evalColumnId: z.string().nullable(),
  reviewerType: ReviewerType,
  userId: z.string().nullable(),
  decision: ResultType,
  reason: z.string(),
  reviewOrder: z.number().int(),
  issues: z.array(CheckResultIssueSchema),
  citations: z.array(CheckResultCitationSchema),
  createdAt: z.string().or(z.date()),
  updatedAt: z.string().or(z.date()),
});

export type CheckResult = z.infer<typeof CheckResultSchema>;
export type CheckResultCitation = z.infer<typeof CheckResultCitationSchema>;
export type CheckResultIssue = z.infer<typeof CheckResultIssueSchema>;
